<template>
  <div
    class="color-container"
    :class="{'color-container--selected' : selected}"
    :id="id"
    @click="emitColor"
  >
    <div
      :style="{'background-color' : color}"
      class="color-container--item"
    ></div>

  </div>
</template>

<script>
export default {
  name: 'ColorSelector',
  props: {
    id: {
      type: String
    },
    color: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean
    }
  },
  methods: {
    emitColor () {
      this.$emit('emitColor', this.color)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-container {
  width: 30px;
  height: 30px;
  background-color: #fff;
  border-radius: 50%;
  position: relative;
  &:hover {
    .color-container--item {
      width: 24px;
      height: 24px;
      left: calc(50% - 24px / 2);
      top: calc(50% - 24px / 2);
    }
  }
  &--selected {
    border: 1px solid var(--semantic-brand-main);
    > .color-container--item {
      width: 24px;
      height: 24px;
      left: calc(50% - 24px / 2);
      top: calc(50% - 24px / 2);
      background-image:url("~@/assets/img/icons/icon-check-small.svg");
      background-repeat: no-repeat;
      background-position: center;
      transition:none;

    }
  }

  &--item {
    width: 16px;
    height: 16px;
    position: absolute;
    border-radius: 50%;
    left: calc(50% - 16px / 2);
    top: calc(50% - 16px / 2);
    transition: all 150ms ease-out;
  }
}
</style>
